<template>
  <div id="app">
    <router-view />
    <div id="poorNetworkR" class="poorNetwork">
      <img src="../public/static/images/default/network_r.png" />
      <p>网络不给力，请重新尝试</p>
      <el-button plain @click="newReload">重新尝试</el-button>
    </div>
    <div id="poorNetworkD" class="poorNetwork">
      <img src="../public/static/images/default/network_d.png" />
      <p>网络似乎出现了问题，请先检查网络状态</p>
      <el-button plain @click="newReload">已检查，重新尝试</el-button>
    </div>
    <div v-if="progressShow && retract == false" class="elPg" @click="retract = true">
      <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage"></el-progress>
    </div>

    <div v-if="progressShow && retract" class="progressBar">
      <div class="pbLeft">
        <span>{{ status == 1 ? '导入' : '导出' }}进度</span>
        <samp @click="retract = false">收起</samp>
      </div>
      <div class="pbMiddle">{{ fileName }}</div>
      <div class="pbBottom">
        <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage"></el-progress>
      </div>
    </div>
    <el-dialog :title="uploadTitle" :visible.sync="uploadVisible" :append-to-body="true" width="602px">
      <div class="upload-body">
        <div>
          1.若无模板，请先
          <a class="dowload_link" :href="downloadLink" :download="uploadTitle == '导入顾客' ? '导入顾客模板.xlsx' : uploadTitle == '导入顾客套餐' ? '导入顾客套餐模板.xlsx' : '导入无手机号顾客套餐模板.xlsx'">下载模板</a> ，并按模板要求填写好信息后上传哦
        </div>
        <div>2.仅支持.xlsx结尾的文件，且单次导入文件数据不能超过3000条，否则将导入失败</div>
        <div>3.选择所需导入的文件</div>
      </div>
      <div class="upload-demo">
        <el-upload ref="upload" :file-list="fileList" :action="uploadLink" :limit="1" accept=".xlsx" :auto-upload="false" :on-change="beforeExcelUpload" :on-exceed="outNumberLimit" :on-success="uploadSuccess" :on-error="uploadSuccess" :before-upload="beforeExcelUpload" :headers="token">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">一次仅能导入一份文件</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <span v-if="uploadTitle != '导入无手机号顾客套餐'" class="tip themeFC" @click="getImportRecordList(1)">
          <i class="el-icon-time" /> 查看导入历史记录
        </span>
        <span v-else class="tip themeFC" @click="jumpNoPhonePackage()">
          <i class="el-icon-time" /> 查看无手机号的顾客套餐
        </span>
        <el-button @click="uploadVisible = false">取消</el-button>
        <el-button type="primary" :disabled="uploadStatus" @click="onConfirmUpload">确定导入</el-button>
      </span>
    </el-dialog>
    <el-dialog class="importDialog" title="导入历史" :visible.sync="historyDialog" width="1000px" :append-to-body="true">
      <el-table tooltip-effect="light" :data="historyTableData" :style="historyTableData.length > 0 ? 'width: 100%' : 'width: 100%;margin-bottom: 20px;'">
        <el-table-column prop="createTime" label="导入时间" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fileName" label="表格名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="staffName" label="操作员工" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="导入结果" width="280">
          <template slot-scope="scope">
            <h6 v-if="scope.row.importStatus == 0"><span class="sOne">失败</span><samp>(导入失败{{ scope.row.errorCount }}条)</samp></h6>
            <h6 v-else-if="scope.row.importStatus == 1"><span class="sTwo">成功</span><samp>(成功导入{{ scope.row.successCount }}条数据)</samp></h6>
            <h6 v-else><span class="sThree">部分失败</span><samp>(成功导入{{ scope.row.successCount }}条，导入失败{{ scope.row.errorCount }}条)</samp></h6>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <yz-btn v-if="scope.row.importStatus != 0" type="primary" @click="onDownloadReport(scope.row.allOriginFilePath)">下载导入报表</yz-btn>
            <yz-btn v-if="scope.row.importStatus != 1" type="delete" @click="onDownloadReport(scope.row.allFilePath)">下载失败报表</yz-btn>
          </template>
        </el-table-column>
      </el-table>
      <span v-if="historyTableData.length > 0" slot="footer" class="dialog-footer">
        <el-pagination :page-size="10" background layout="prev, pager, next, jumper" :total="historyTabletotal" @current-change="getImportRecordList"></el-pagination>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getImportRecordList, getProcessProgress, randomProcessId, getImportMsg, getExportMsg
} from './views/index/api';
import axios from './http/index';
import port from './assets/js/exportFile';

export default {
  name: 'App',
  data() {
    return {
      // 6.0
      uploadTitle: '',
      uploadVisible: false,
      downloadLink: '',
      uploadLink: '',
      fileList: [],
      token: {
        Authorization: sessionStorage.getItem('token')
      },
      uploadStatus: true,
      historyDialog: false,
      historyTableData: [{}, {}],
      historyTabletotal: 0,
      progressShow: false, // 是否展示进度条
      retract: true,
      percentage: 0,
      fileName: '',
      status: 1, // 1导入  2导出
    };
  },
  watch: {
    $route() {
      const data = { busId: sessionStorage.getItem('busId') };
      window.gtMaiDian && window.gtMaiDian.sendData(data);
    }
  },
  // mounted中检测是否断网
  mounted() {
    // 检测断网
    window.addEventListener('offline', () => {
      $('#poorNetworkD').css('display', 'block');
      $('#poorNetworkR').css('display', 'none');
    });
    window.addEventListener('online', () => {
      $('#poorNetworkD').css('display', 'none');
    });
    if (window.sessionStorage.processId) {
      this.processId = window.sessionStorage.processId;
      this.fileName = window.sessionStorage.fileName;
      this.progressShow = true;
      this.getProcessProgress();
    }
  },
  methods: {
    // 6.82 查看无手机号顾客套餐
    jumpNoPhonePackage() {
      // if (this.Lib.checkPower('beauty-2-drwsjhgktcxx') == false) return;
      this.$router.push({
        name: 'customer-noPhone'
      });
    },
    fatherImport(val) {
      this.getRandomProcessId(val);
    },
    exportInterface(url) {
      if (this.progressShow) {
        this.$message('有内容正在下载');
        return;
      }
      this.progressShow = true;
      randomProcessId({}).then((res) => {
        this.status = 2;
        this.processId = res.data;
        const newUrl = `${url}&processId=${this.processId}`;
        axios.get(newUrl).then((resTwo) => {
          if (resTwo.data.code == 0) {
            window.sessionStorage.processId = this.processId;
            // window.sessionStorage.fileName = this.fileName;
            this.getProcessProgressExport();
          } else {
            this.progressShow = false;
            console.log(resTwo);
          }
        });
      });
    },
    exportInterfacePost(url, obj) {
      if (this.progressShow) {
        this.$message('有内容正在下载');
        return;
      }
      this.progressShow = true;
      randomProcessId({}).then((res) => {
        this.status = 2;
        this.processId = res.data;
        obj.processId = res.data;
        axios.post(url, obj).then((resTwo) => {
          if (resTwo.data.code == 0) {
            window.sessionStorage.processId = this.processId;
            this.getProcessProgressExport();
          } else {
            this.progressShow = false;
            console.log(resTwo);
          }
        });
      });
    },
    downloadFile(item) {
      const newUrl = `${this.Lib.A() + item[0]}?beginTime=${item[1]}&endTime=${item[2]}&mainId=${sessionStorage.getItem('mainId')}&dateTime=${item[3]}&text=${item[4] || ''}&pageNum=${item[5]}&countType=${item[6]}&technicianId=${item[7]}&itemId=${item[8]}&productId=${item[9]}&vipCardId=${item[10]}&standardId=${item[11]}&isRead=${item[12] ? 0 : 0}&sortKeyWord=${item[13]}&sortType=${item[14]}&isAsc=${item[15]}&timeCountType=${item[16]}&dateType=${item[17]}&sort=${item[18]}&sortBy=${item[19]}`;
      this.exportInterface(newUrl);
    },
    downloadFileN(item) {
      const newUrl = `${this.Lib.A() + item[0]}?startTime=${item[1]}&beginTime=${item[2]}&endTime=${item[3]}&mainId=${sessionStorage.getItem('mainId')}&sortKeyWord=${item[4]}&sortType=${item[5]}&dateType=${item[6]}`;
      this.exportInterface(newUrl);
    },
    // 营销统计
    downloadFileTow(item) {
      const newUrl = `${this.Lib.A() + item[0]}?beginTime=${item[1]}&endTime=${item[2]}&mainId=${sessionStorage.getItem('mainId')}&dateTime=${item[3]}&text=${item[4] || ''}&pageNum=${item[5]}&countType=${item[6]}&technicianId=${item[7]}&itemId=${item[8]}&productId=${item[9]}&vipCardId=${item[10]}&standardId=${item[11]}&isRead=${item[12]}&sortKeyWord=${item[13]}&sortType=${item[14]}&timeCountType=${item[15]}`;
      this.exportInterface(newUrl);
    },
    // (5.9)导出美容套餐列表
    downloadFileCustomer(item) {
      const newUrl = `${this.Lib.A() + item[0]}?phone=${item[1]}&useType=${item[2]}&mainId=${sessionStorage.getItem('mainId')}`;
      this.exportInterface(newUrl);
    },
    // 5.10-统计优化导出
    downStatistics(item) {
      const newUrl = `${this.Lib.A() + item[0]}?beginTime=${item[1]}&endTime=${item[2]}&dateType=${item[3]}&mainId=${sessionStorage.getItem('mainId')}`;
      this.exportInterface(newUrl);
    },
    // 清除选择文件与进度条
    clearFJ() {
      clearInterval(this.timer);
      setTimeout(() => {
        this.progressShow = false;
        this.percentage = 0;
      }, 1000);
      this.uploadStatus = true;
    },
    // 获取导入ID
    getRandomProcessId(val) {
      if (this.progressShow) {
        this.$message('有内容正在上传');
        return;
      }
      randomProcessId({}).then((res) => {
        this.status = 1;
        if (res.code === 0) {
          this.processId = res.data;
          this.uploadVisible = true;
          if (val === 1) {
            this.uploadTitle = '导入顾客';
            this.uploadLink = `${this.Lib.A()}/erp/customer/parseCustomerExcelData?importId=${this.processId}&mainId=${window.sessionStorage.mainId}`;
            this.downloadLink = '/static/erp/static/导入顾客模板.xlsx';
          } else if (val === 2) {
            this.uploadTitle = '导入顾客套餐';
            this.uploadLink = `${this.Lib.A()}/erp/customer/parseCustomerPackageExcelData?importId=${this.processId}&mainId=${window.sessionStorage.mainId}`;
            this.downloadLink = '/static/erp/static/导入顾客套餐模板.xlsx';
          } else if (val === 3) {
            this.uploadTitle = '导入无手机号顾客套餐';
            this.uploadLink = `${this.Lib.A()}/erp/customer/parseNoPhoneCustomerPackageExcelData?importId=${this.processId}&mainId=${window.sessionStorage.mainId}`;
            this.downloadLink = '/static/erp/static/导入无手机号顾客套餐模板.xlsx';
          }
        } else {
          console.log(res);
        }
      });
    },
    // 获取导入进度
    getProcessProgress() {
      this.timer = setInterval(async () => {
        const data = {
          processId: this.processId
        };
        getProcessProgress(data).then((res) => {
          if (res.code === 0) {
            this.percentage = res.data;
            if (res.data === 100) {
              this.clearFJ();
              setTimeout(() => {
                this.getImportStatus();
              }, 1000);
            }
          }
        });
      }, 1000);
    },
    // 获取导出进度
    getProcessProgressExport() {
      this.timer = setInterval(async () => {
        const data = {
          processId: this.processId
        };
        getProcessProgress(data).then((res) => {
          if (res.code === 0) {
            this.percentage = res.data;
            if (res.data === 100) {
              this.clearFJ();
              setTimeout(() => {
                this.getExportStatus();
              }, 1000);
            }
          }
        });
      }, 1000);
    },
    // 获取导出数据和状态
    getExportStatus() {
      getExportMsg({ processId: this.processId }).then((res) => {
        if (res.code === 0) {
          this.endTip(res.data);
          window.sessionStorage.processId = '';
          window.sessionStorage.fileName = '';
        }
      });
    },
    // 获取导入数据和状态
    getImportStatus() {
      getImportMsg({ processId: this.processId }).then((res) => {
        if (res.code === 0) {
          this.endTip(res.data);
          window.sessionStorage.processId = '';
          window.sessionStorage.fileName = '';
          if (window.location.href.indexOf('/customer/manage') > -1 && res.data.successCount) {
            $('#customerId .dfoot').click();
          }
        }
      });
    },
    // 提示
    endTip(data) {
      const {
        fileName, importStatus, successCount, errorCount, exportStatus
      } = data;
      let msg = '';
      if (this.status == 1) {
        if (importStatus == 1) {
          msg = `<div class="notifyMsg"><div class="nsLeft"><i class="el-icon-success"></i></div><div class="nsRight"><p class="text-warning">${fileName}</p><h4>导入完成，成功<span class="main-color"> ${successCount} </span>条，失败<span class="text-danger"> ${errorCount} </span>条。</h4></div></div>`;
        } else if (importStatus == 2) {
          msg = '<div class="notifyMsg"><div class="nsLeft"><i class="el-icon-error"></i></div><div class="nsRight">导入失败，导入的文件无法识别，可能不被支持 或被加密！</div></div>';
        } else {
          msg = `<div class="notifyMsg"><div class="nsLeft"><i class="el-icon-success"></i></div><div class="nsRight"><p class="text-warning">${fileName}</p><h4>导入完成，成功<span class="main-color"> ${successCount} </span>条，失败<span class="text-danger"> ${errorCount} </span>条。</h4><h5>下载错误报告</h5></div></div>`;
        }
        this.$notify({
          title: '导入提示',
          dangerouslyUseHTMLString: true,
          message: msg,
          position: 'bottom-right',
          duration: 180000,
          onClick: () => {
            this.errorReport(data);
          }
        });
      }
      if (this.status == 2) {
        if (exportStatus == 1) {
          msg = `<div class="notifyMsg"><div class="nsLeft"><i class="el-icon-success"></i></div><div class="nsRight"><p class="text-warning">${fileName}</p><h4>成功导出</h4></div></div>`;
        }
        this.$notify({
          title: '导出提示',
          dangerouslyUseHTMLString: true,
          message: msg,
          position: 'bottom-right',
          duration: 3600,
        });
        window.location.href = data.allFilePath;
        // window.open(data.allFilePath);
      }
    },
    // 获取错误报告
    errorReport(item) {
      window.location.href = item.allFilePath;
      // window.open(item.allFilePath);
    },
    // 选择文件之后--6.0
    beforeExcelUpload(file) {
      this.fileName = file.name;
      const fileName = file.name.split('.');
      this.fileList = [file];
      if (fileName[fileName.length - 1] != 'xlsx') {
        this.$message.error('上传的文件只能是 xlsx 格式');
        this.$refs.upload.clearFiles();
        return false;
      }
      this.uploadStatus = false;
    },
    uploadSuccess(res) {
      if (res.code == 0) {
        this.percentage = 0;
        this.progressShow = true;
        this.uploadVisible = false;
        window.sessionStorage.processId = this.processId;
        window.sessionStorage.fileName = this.fileName;
        setTimeout(() => {
          this.$refs.upload.clearFiles(this.timer);
        }, 2000);
        this.getProcessProgress();
      } else {
        this.$message(res.msg);
        setTimeout(() => {
          this.$refs.upload.clearFiles(this.timer);
          this.uploadStatus = false;
        }, 300);
      }
    },
    // 超过个数限制--6.0
    outNumberLimit() {
      this.$message.error('只能上传一个xlsx文件');
    },
    // 确定上传
    onConfirmUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
        this.uploadStatus = true;
      } else {
        this.$message.error('请选择上传文件');
        this.uploadStatus = true;
      }
    },
    // 下载错误报告
    onDownloadReport(allFilePath) {
      window.open(allFilePath);
    },
    // 获取顾客导入历史利率
    getImportRecordList(val) {
      const data = {
        mainId: sessionStorage.getItem('mainId'),
        pageNum: val,
        type: this.uploadTitle == '导入顾客' ? 0 : 1
      };
      getImportRecordList(data).then((res) => {
        this.historyTableData = res.data.records;
        this.historyTabletotal = res.data.total;
        this.historyDialog = true;
      });
    },
    newReload() {
      window.location.reload();
    },
    fatherExport(val, a, b, c, d, e, f, g) {
      switch (val) {
        case 'exportIncomeDetail':
          this.fileName = '收入明细';
          window.sessionStorage.fileName = '收入明细';
          this.downloadFile(port.exportIncomeDetail(a, b, c, d, e, f, g));
          break;
        case 'exportDiscoutDtails':
          this.fileName = '优惠明细';
          window.sessionStorage.fileName = '优惠明细';
          this.downloadFile(port.exportDiscoutDtails(a, b, c, d, e, f, g));
          break;
        case 'exportDeductDtails':
          this.fileName = '划扣金额明细';
          window.sessionStorage.fileName = '划扣金额明细';
          this.downloadFile(port.exportDeductDtails(a, b, c, d, e, f, g));
          break;
        case 'exportDebtDtails':
          this.fileName = '应收欠款明细';
          window.sessionStorage.fileName = '应收欠款明细';
          this.downloadFile(port.exportDebtDtails(a, b, c, d, e, f, g));
          break;
        case 'exportPayDetails':
          this.fileName = '支付明细';
          window.sessionStorage.fileName = '支付明细';
          this.downloadFile(port.exportPayDetails(a, b, c, d, e, f, g));
          break;
        case 'exportRefundDtails':
          this.fileName = '退款明细';
          window.sessionStorage.fileName = '退款明细';
          this.downloadFile(port.exportRefundDtails(a, b, c, d, e, f, g));
          break;
        case 'exportProductIncome':
          this.fileName = '产品收入';
          window.sessionStorage.fileName = '产品收入';
          this.downloadFile(port.exportProductIncome(a, b, c, d, e, f, g));
          break;
        case 'exportVipCardIncome':
          this.fileName = '套餐收入';
          window.sessionStorage.fileName = '套餐收入';
          this.downloadFile(port.exportVipCardIncome(a, b, c, d, e, f, g));
          break;
        case 'exportFastIncome':
          this.fileName = '快捷收银';
          window.sessionStorage.fileName = '快捷收银';
          this.downloadFile(port.exportFastIncome(a, b, c, d, e, f, g));
          break;
        case 'exportIncomeData':
          this.fileName = '收入明细列表详情';
          window.sessionStorage.fileName = '收入明细列表详情';
          this.downloadFile(port.exportIncomeData(a, b, c, d, e, f, g));
          break;
        case 'exportDiscoutData':
          this.fileName = '优惠明细列表详情';
          window.sessionStorage.fileName = '优惠明细列表详情';
          this.downloadFile(port.exportDiscoutData(a, b, c, d, e, f, g));
          break;
        case 'exportDeductData':
          this.fileName = '划扣金额明细详情';
          window.sessionStorage.fileName = '划扣金额明细详情';
          this.downloadFile(port.exportDeductData(a, b, c, d, e, f, g));
          break;
        case 'exportDebtData':
          this.fileName = '应收欠款明细详情';
          window.sessionStorage.fileName = '应收欠款明细详情';
          this.downloadFile(port.exportDebtData(a, b, c, d, e, f, g));
          break;
        case 'exportIncomeDetails':
          this.fileName = '支付明细详情';
          window.sessionStorage.fileName = '支付明细详情';
          this.downloadFile(port.exportIncomeDetails(a, b, c, d, e, f, g));
          break;
        case 'exportRefundAnalyse':
          this.fileName = '退款明细详情';
          window.sessionStorage.fileName = '退款明细详情';
          this.downloadFile(port.exportRefundAnalyse(a, b, c, d, e, f, g));
          break;
        case 'exportAchivement':
          this.fileName = '营业概况';
          window.sessionStorage.fileName = '营业概况';
          this.downloadFile(port.exportAchivement(a, b, c, d, e, f, g));
          break;
        case 'exportPercentageCount':
          this.fileName = '提成概况';
          window.sessionStorage.fileName = '提成概况';
          this.downloadFile(port.exportPercentageCount(a, b, c, d, e, f, g));
          break;
        case 'exportStaffAchivement':
          this.fileName = '员工业绩与提成';
          window.sessionStorage.fileName = '员工业绩与提成';
          this.downloadFile(port.exportStaffAchivement(a, b, c, d, e, f, g));
          break;
        case 'exportProductDtails':
          this.fileName = '员工产品详情';
          window.sessionStorage.fileName = '员工产品详情';
          this.downloadFile(port.exportProductDtails(a, b, c, d, e, f, g));
          break;
        case 'exportVipCardDtails':
          this.fileName = '员工套餐详情';
          window.sessionStorage.fileName = '员工套餐详情';
          this.downloadFile(port.exportVipCardDtails(a, b, c, d, e, f, g));
          break;
        case 'exportServeDtails':
          this.fileName = '员工项目详情';
          window.sessionStorage.fileName = '员工项目详情';
          this.downloadFile(port.exportServeDtails(a, b, c, d, e, f, g));
          break;
        case 'exportServeSaleDetails':
          this.fileName = '员工项目销售详情';
          window.sessionStorage.fileName = '员工项目销售详情';
          this.downloadFile(port.exportServeSaleDetails(a, b, c, d, e, f, g));
          break;
        case 'exportDeductServeDtails':
          this.fileName = '员工项目劳动-区分划扣详情';
          window.sessionStorage.fileName = '员工项目劳动-区分划扣详情';
          this.downloadFile(port.exportDeductServeDtails(a, b, c, d, e, f, g));
          break;
        case 'exportLookSellDTO':
          this.fileName = '销售达标详情';
          window.sessionStorage.fileName = '销售达标详情';
          this.downloadFile(port.exportLookSellDTO(a, b, c, d, e, f, g));
          break;
        case 'exportWorkDTO':
          this.fileName = '劳动达标详情';
          window.sessionStorage.fileName = '劳动达标详情';
          this.downloadFile(port.exportWorkDTO(a, b, c, d, e, f, g));
          break;
        case 'exportDeductWorkDTO':
          this.fileName = '劳动达标-区分划扣详情';
          window.sessionStorage.fileName = '劳动达标-区分划扣详情';
          this.downloadFile(port.exportDeductWorkDTO(a, b, c, d, e, f, g));
          break;
        case 'exportDayStaffErrorOrderMsgList':
          this.fileName = '已处理的异常订单详情';
          window.sessionStorage.fileName = '已处理的异常订单详情';
          this.downloadFile(port.exportDayStaffErrorOrderMsgList(a, b, c, d, e, f, g));
          break;
        case 'exportOrderTotalDTO':
          this.fileName = '业绩订单详情';
          window.sessionStorage.fileName = '业绩订单详情';
          this.downloadFile(port.exportOrderTotalDTO(a, b, c, d, e, f, g));
          break;
        case 'exportBookTechnicianDetails':
          this.fileName = '预约统称详情';
          window.sessionStorage.fileName = '预约统称详情';
          this.downloadFile(port.exportBookTechnicianDetails(a, b, c, d, e, f, g));
          break;
        case 'exportBookServeDetails':
          this.fileName = '预约项目详情';
          window.sessionStorage.fileName = '预约项目详情';
          this.downloadFile(port.exportBookServeDetails(a, b, c, d, e, f, g));
          break;
        case 'exportRoomDetail':
          this.fileName = '房间预定';
          window.sessionStorage.fileName = '房间预定';
          this.downloadFile(port.exportRoomDetail(a, b, c, d, e, f, g));
          break;
        case 'exportRoomBedDetail':
          this.fileName = '台位预定详情';
          window.sessionStorage.fileName = '台位预定详情';
          this.downloadFile(port.exportRoomBedDetail(a, b, c, d, e, f, g));
          break;
        case 'exportServeSaleItemDetails':
          this.fileName = '员工项目销售明细';
          window.sessionStorage.fileName = '员工项目销售明细';
          this.downloadFile(port.exportServeSaleItemDetails(a, b, c, d, e, f, g));
          break;
        case 'exportProductSaleItemDetails':
          this.fileName = '员工产品销售明细';
          window.sessionStorage.fileName = '员工产品销售明细';
          this.downloadFile(port.exportProductSaleItemDetails(a, b, c, d, e, f, g));
          break;
        case 'exportPackageSaleItemDetails':
          this.fileName = '员工套餐销售明细';
          window.sessionStorage.fileName = '员工套餐销售明细';
          this.downloadFile(port.exportPackageSaleItemDetails(a, b, c, d, e, f, g));
          break;
        case 'exportServeItemDetails':
          this.fileName = '员工项目劳动明细';
          window.sessionStorage.fileName = '员工项目劳动明细';
          this.downloadFile(port.exportServeItemDetails(a, b, c, d, e, f, g));
          break;
        case 'exportSellDetailDTO':
          this.fileName = '销售达标详情明细';
          window.sessionStorage.fileName = '销售达标详情明细';
          this.downloadFile(port.exportSellDetailDTO(a, b, c, d, e, f, g));
          break;
        case 'exportWorkDetailDTO':
          this.fileName = '劳动达标详情明细';
          window.sessionStorage.fileName = '劳动达标详情明细';
          this.downloadFile(port.exportWorkDetailDTO(a, b, c, d, e, f, g));
          break;
        case 'exportOneStaffFinishErrorOrderMsgList':
          this.fileName = '已处理的异常订单详情';
          window.sessionStorage.fileName = '已处理的异常订单详情';
          this.downloadFile(port.exportOneStaffFinishErrorOrderMsgList(a, b, c, d, e, f, g));
          break;
        case 'exportMemberCount':
          this.fileName = '客流明细分析';
          window.sessionStorage.fileName = '客流明细分析';
          this.downStatistics(port.exportMemberCount(a, b, c, d, e, f, g));
          break;
        case 'exportCustomerAndMember':
          this.fileName = '新增顾客明细';
          window.sessionStorage.fileName = '新增顾客明细';
          this.downStatistics(port.exportCustomerAndMember(a, b, c, d, e, f, g));
          break;
        case 'exportItemDetails':
          this.fileName = '项目收入详情';
          window.sessionStorage.fileName = '项目收入详情';
          this.downloadFile(port.exportItemDetails(a, b, c, d, e, f, g));
          break;
        case 'exportProductDetails':
          this.fileName = '产品收入详情';
          window.sessionStorage.fileName = '产品收入详情';
          this.downloadFile(port.exportProductDetails(a, b, c, d, e, f, g));
          break;
        case 'exportVipCardDetails':
          this.fileName = '套餐收入详情';
          window.sessionStorage.fileName = '套餐收入详情';
          this.downloadFile(port.exportVipCardDetails(a, b, c, d, e, f, g));
          break;
        case 'exportItemIncome':
          this.fileName = '项目收入-分类汇总';
          window.sessionStorage.fileName = '项目收入-分类汇总';
          this.downloadFileTow(port.exportItemIncome(a, b, c, d, e, f, g));
          break;
        case 'exportItemPool':
          this.fileName = '项目收入-项目汇总';
          window.sessionStorage.fileName = '项目收入-项目汇总';
          this.downloadFileTow(port.exportItemPool(a, b, c, d, e, f, g));
          break;
        case 'exportBookDetails':
          this.fileName = '预约明细';
          window.sessionStorage.fileName = '预约明细';
          this.downloadFile(port.exportBookDetails(a, b, c, d, e, f, g));
          break;
        case 'exportBookSource':
          this.fileName = '预约来源';
          window.sessionStorage.fileName = '预约来源';
          this.downloadFile(port.exportBookSource(a, b, c, d, e, f, g));
          break;
        case 'exportBookServe':
          this.fileName = '预约项目';
          window.sessionStorage.fileName = '预约项目';
          this.downloadFile(port.exportBookServe(a, b, c, d, e, f, g));
          break;
        case 'exportBookTechnician':
          this.fileName = `预约${this.Lib.collectively()}`;
          window.sessionStorage.fileName = `预约${this.Lib.collectively()}`;
          this.downloadFile(port.exportBookTechnician(a, b, c, d, e, f, g));
          break;
        case 'exportBookRoom':
          this.fileName = '房间预订';
          window.sessionStorage.fileName = '房间预订';
          this.downloadFile(port.exportBookRoom(a, b, c, d, e, f, g));
          break;
        case 'exportBookRoomBed':
          this.fileName = '台位预订分析';
          window.sessionStorage.fileName = '台位预订分析';
          this.downloadFile(port.exportBookRoomBed(a, b, c, d, e, f, g));
          break;
        case 'exportTechnicianBook':
          this.fileName = `预约${this.Lib.collectively()}分析`;
          window.sessionStorage.fileName = `预约${this.Lib.collectively()}分析`;
          this.downloadFile(port.exportBookTechnician(a, b, c, d, e, f, g));
          break;
        case 'exportTechnicianBookDetail':
          this.fileName = `预约${this.Lib.collectively()}分析详情`;
          window.sessionStorage.fileName = `预约${this.Lib.collectively()}分析详情`;
          this.downloadFile(port.exportTechnicianBookDetail(a, b, c, d, e, f, g));
          break;
        case 'exportVipCardDeduct':
          this.fileName = '套餐划扣';
          window.sessionStorage.fileName = '套餐划扣';
          this.downloadFileN(port.exportVipCardDeduct(a, b, c, d, e, f, g));
          break;
        case 'exportVipCardSaleDetailPage':
          this.fileName = '套餐销售';
          window.sessionStorage.fileName = '套餐销售';
          this.downloadFileN(port.exportVipCardSaleDetailPage(a, b, c, d, e, f, g));
          break;
        case 'exportBeautyPackageList':
          this.fileName = '美容套餐';
          window.sessionStorage.fileName = '美容套餐';
          this.downloadFileCustomer(port.exportBeautyPackageList(a, b, c, d, e, f, g));
          break;
        case 'exportItemSaleRiseList':
          this.fileName = '销售分析-项目分析增长明细';
          window.sessionStorage.fileName = '销售分析-项目分析增长明细';
          this.downStatistics(port.exportItemSaleRiseList(a, b, c, d, e, f, g));
          break;
        case 'exportProductSaleRiseList':
          this.fileName = '销售分析-产品分析增长明细';
          window.sessionStorage.fileName = '销售分析-产品分析增长明细';
          this.downStatistics(port.exportProductSaleRiseList(a, b, c, d, e, f, g));
          break;
        case 'exportTechnicianSaleAnalyseMsg':
          this.fileName = '销售分析-员工销售明细';
          window.sessionStorage.fileName = '销售分析-员工销售明细';
          this.downStatistics(port.exportTechnicianSaleAnalyseMsg(a, b, c, d, e, f, g));
          break;
        case 'exportTechnicianServeAnalyseMsg':
          this.fileName = '销售分析-员工劳动明细';
          window.sessionStorage.fileName = '销售分析-员工劳动明细';
          this.downStatistics(port.exportTechnicianServeAnalyseMsg(a, b, c, d, e, f, g));
          break;
        case 'exportCustomerList':
          this.fileName = '顾客列表';
          window.sessionStorage.fileName = '顾客列表';
          this.exportInterface(a);
          break;
        case 'exportCustomerPackageList':
          this.fileName = '顾客套餐信息';
          window.sessionStorage.fileName = '顾客套餐信息';
          this.exportInterface(a);
          break;
        case 'exportGiftStatistics':
          this.fileName = '赠送商品统计';
          window.sessionStorage.fileName = '赠送商品统计';
          // this.downloadFileTow(port.exportItemIncome(a, b, c, d, e, f, g));
          this.downStatistics(port.exportGiftStatistics(a, b, c, d, e, f, g));
          break;
        case 'exportAllOrderList':
          this.fileName = '导出订单';
          window.sessionStorage.fileName = '导出订单';
          this.exportInterfacePost(a, b);
          break;
        default:
          break;
      }
    },
  }
};
</script>
<style lang="less">
// 6.8.2
.importDialog {
  width: 100%;
  h6 {
    font-size: 14px;
    color: #333;
    .sOne {
      color: #f56c6c;
    }
    .sTwo {
      color: #333;
    }
    .sThree {
      color: #67c23a;
    }
    samp {
      color: #999;
    }
  }
}
// 6.0
.upload-body {
  padding-bottom: 10px;
  > div {
    padding: 10px 0;
    &:first-child {
      padding-top: 0;
    }
  }
}
.upload-demo {
  width: 500px;
  height: 100px;
  padding: 20px;
  border-radius: 4px;
  border: solid 1px #d8dce5;
  margin-bottom: 20px;
}
.tip {
    font-size: 13px;
    float: left;
    line-height: 35px;
    margin-left: 10px;
    cursor: pointer;
}
.history_button_err {
    width: 54px;
    height: 28px;
    background: rgba(254, 240, 240, 1);
    border: 1px solid rgba(253, 226, 226, 1);
    border-radius: 4px;
    font-size: 12px;
    color: #f56c6c;
    text-align: center;
    line-height: 28px;
}
.history_button_win {
    width: 54px;
    height: 28px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
    font-size: 12px;
    color: #67c23a;
    text-align: center;
    line-height: 28px;
}
.elPg {
  position: absolute;
  z-index: 99;
  width: 200px;
  bottom: 90px;
  right: -90px;
  transform: rotate(-90deg);
  font-size: 14px;
  line-height: 18px;
  border: 4px solid #fff;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  cursor: pointer;
}
.progressBar {
  position: absolute;
  right: 20px;
  bottom: 20px;
  background-color: #fff;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 9999;
  width: 400px;
  padding: 20px;
  .pbLeft {
    height: 18px;
    line-height: 18px;
    margin-bottom: 20px;
    span {
      font-size: 18px;
      color: #333;
      float: left;
    }
    samp {
      font-size: 14px;
      color: #409EFF;
      float: right;
      cursor: pointer;
    }
  }
  .pbMiddle {
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    color: #FF822F;
    margin-bottom: 20px;
  }
}
</style>
<style>
* {
    padding: 0;
    margin: 0;
}
html,
body {
    font-family: "Microsoft YaHei";
}
#indexTheme {
    overflow: hidden;
    padding-right: 0 !important;
}
.poorNetwork {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #fff;
  display: none;
  z-index: 99999;
}
.poorNetwork img{
  margin: 20% auto 0 auto;
  display: block;
}
.poorNetwork p {
  font-size: 18px;
  color: #666;
  margin: 20px 0;
  text-align: center;
}
.poorNetwork .el-button {
  margin: 0 auto;
  display: block;
}
/* 6.0 */
.el-notification {
  padding-left: 14px !important;
  width: 400px;
}
.el-upload-list__item .el-progress {
  display: none;
}
.el-table__fixed-right::before, .el-table__fixed::before {
  height: 0;
}
.text-warning {
  font-size: 14px;
  color: #FF822F;
}
.main-color {
  font-size: 14px;
  color: #409EFF;
}
.text-danger {
  font-size: 14px;
  color: #F56C6C;
}
.notifyMsg {
  margin-top: 15px;
  display: flex;
}
.notifyMsg .nsLeft {
  margin: 8px 15px 8px 0;
}
.notifyMsg .nsLeft i {
  font-size: 25px;
}
.notifyMsg .nsRight {
  flex: 1;
  white-space: pre-wrap;
  line-height: 21px;
}
.notifyMsg .nsRight p {
  height: 17px;
  line-height: 17px;
}
.notifyMsg .nsRight h4 {
  height: 24px;
  line-height: 24px;
}
.notifyMsg .nsRight h5 {
  height: 16px;
  line-height: 16px;
  color: #409EFF;
  cursor: pointer;
}
</style>
